module.exports = __webpack_public_path__ + "img/REECH_logo.cf16a52e.png";